import React from 'react';
import Button from 'react-bootstrap/Button';
import "./Ability.css"


const AbilityModal = ({ ability, onClose, abilities }) => {

    const matchingAbility = abilities.find((item) => item.name === ability);

    const imageSrc = matchingAbility?.image || `/assets/icons/abilities/${ability}.png`;
    return (
        <div className="ability-component">
            <div className={`grey card ${onClose ? 'modal-centered' : ''}`} style={onClose ? {backgroundColor: "#6B6450"} : {}}>
                <div className="card-header grey ability-header" style={onClose ? {backgroundColor: "#6B6450"} : {}}>
                    <div className="modal-title d-flex align-items-center justify-content-center">
                        <img
                            src={imageSrc}
                            style={{ filter: 'url(#shadow)', width: '60px', height: '60px', objectFit: 'contain' }}
                            alt={ability}
                            className="ability-icon-modal me-2"
                        />
                        <span>{ability}</span>
                    </div>
                </div>
                <div className="card-body" style={onClose ? {backgroundColor: "#6B6450"} : {}}>
                    <div>
                        <p>{matchingAbility?.description ?? 'Description unavailable.'}</p>
                    </div>
                </div>
                {onClose && (
                    <Button variant="secondary" onClick={onClose} style={{background: "tan"}}>
                        Close
                    </Button>
                )}
            </div>
        </div>
    );
};

export default AbilityModal;
